export enum DialogType {
  Simple = 'simple',
  Maximizable = 'maximizable',
  Draggable = 'draggable',
  All = 'all',
}
